module.exports = __webpack_public_path__ + "static/rajani-0c4ca652524b9dfbc108a88249791a38.png";